import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = { class: "p-field-label" }
const _hoisted_4 = { class: "p-field-label" }
const _hoisted_5 = { class: "d-flex justify-content-end mt-3 mb-5 fs-14 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumToRadioButton = _resolveComponent("EnumToRadioButton")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ObjectIsUpper")), 1),
    _createVNode(_component_EnumToRadioButton, {
      modelValue: _ctx.triggerOrActionToAdd.thermostatState,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerOrActionToAdd.thermostatState = $event)),
      enum: _ctx.SceneThermostatState
    }, null, 8, ["modelValue", "enum"]),
    (_ctx.isStateComparerManagementAvailable)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.IsUpper")), 1),
          _createVNode(_component_EnumToRadioButton, {
            modelValue: _ctx.triggerOrActionToAdd.stateComparer,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.triggerOrActionToAdd.stateComparer = $event)),
            enum: _ctx.SceneStateComparer,
            "disabled-choices": _ctx.sceneStateComparerDisabledChoices
          }, null, 8, ["modelValue", "enum", "disabled-choices"])
        ], 64))
      : _createCommentVNode("", true),
    (
                _ctx.isTemperatureManagementAvailable ||
                _ctx.isThermoConditionManagementAvailable ||
                _ctx.isThermoModalityManagementAvailable
            )
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ToUpper")), 1),
          (_ctx.isTemperatureManagementAvailable)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Slider, {
                  class: "mt-3",
                  modelValue: _ctx.triggerOrActionToAdd.thermostatTemperature,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerOrActionToAdd.thermostatTemperature = $event)),
                  min: _ctx.sliderMin,
                  max: _ctx.sliderMax,
                  step: 1
                }, null, 8, ["modelValue", "min", "max"]),
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", null, _toDisplayString(_ctx.triggerOrActionToAdd.thermostatTemperature) + "°C ", 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isThermoConditionManagementAvailable)
            ? (_openBlock(), _createBlock(_component_EnumToRadioButton, {
                key: 1,
                modelValue: _ctx.triggerOrActionToAdd.thermostatConditionState,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.triggerOrActionToAdd.thermostatConditionState = $event)),
                enum: _ctx.SceneThermostatConditionState
              }, null, 8, ["modelValue", "enum"]))
            : _createCommentVNode("", true),
          (_ctx.isThermoModalityManagementAvailable)
            ? (_openBlock(), _createBlock(_component_EnumToRadioButton, {
                key: 2,
                modelValue: _ctx.triggerOrActionToAdd.thermostatModalityState,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.triggerOrActionToAdd.thermostatModalityState = $event)),
                enum: _ctx.SceneThermostatModalityState
              }, null, 8, ["modelValue", "enum"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}